import React, { useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import ResearcherProfile from "./charts/rs/profile";
import ResearcherEditProfile from "./charts/rs/editProfile";
import Dashboard from "./charts/rs/dashboard";
import PubStudyAreaDist from "./charts/rs/pubStudyAreaDist";
import PubStudyCategoryDist from "./charts/rs/pubStudyCategoryDist";
import PubCountByYears from "./charts/rs/pubCountByYears";
import LecturingScore from "./charts/rs/lecturingScore";
import Journals from "./charts/rs/journals";
import Courses from "./charts/rs/courses";
import QDist from "./charts/rs/qDist";

import OUDashboard from "./charts/ou/dashboard";
import OUPubStudyAreaDist from "./charts/ou/pubStudyAreaDist";
import OUPubStudyCategoryDist from "./charts/ou/pubStudyCategoryDist";
import OUPubCountByYears from "./charts/ou/pubCountByYears";
import OUJournals from "./charts/ou/journals";
import OUQDist from "./charts/ou/qDist";

import MakaleSayisi from "./charts/home/makaleSayisi";
import DergiDagilimi from "./charts/home/dergiDagilimi";
import EnCokAtif from "./charts/home/enCokAtif";

import ReportsQDist from "./charts/reports/qDist";
import ReportsYayinSayisi from "./charts/reports/yayinSayisi";
import ReportsMasterTeziSayisiSayisi from "./charts/reports/masterTeziSayisi";
import ReportsDoktoraTeziSayisiSayisi from "./charts/reports/doktoraTeziSayisi";
import ScimagoTurkey from "./charts/reports/scimagoTurkey";
import ScimagoWorldwide from "./charts/reports/scimagoWorldwide";

import Awards from "./charts/awards/awards";
import Equipments from "./charts/equipments/equipments";
import { useExternalScript } from "./hooks/util/external-script";
import ReactGA from "react-ga";
import { HandleVistorChart } from "./charts/handle/handleVisitorChart";
import Sobiad from "./charts/handle/sobiad";
import SemanticScholar from "./charts/handle/semantic-scholar";
import OpenCitations from "./charts/handle/open-citations";
import SemanticScholarRecommendationTable from "./charts/handle/semantic-scholar-recommendation-table";
import ReportsWorldChart from "./charts/reports/reportsWorldChart";
import OrgUnitSdgWall from "./charts/ou/sdgWall";
import HandleSdgWall from "./charts/handle/sdgWall";

const TRACKING_ID = window._env_.GOOGLE_ANALYTICS_ID;
ReactGA.initialize(TRACKING_ID);

function Home() {
  return (
    <div>
      <h1>Grandcris Chart Generator</h1>
      <p>BASE_URL: {window._env_.BASE_URL}</p>
    </div>
  );
}

function App() {
  const loading = useExternalScript(
    window._env_.BASE_URL + "/static/js/iframeResizer.contentWindow.min.js"
  );
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  return (
    <Router>
      <Switch>
        {loading === "ready" && (
          <>
            <Route exact path="/stats/" basename={"/stats"} component={Home} />
            <Route path="/stats/rs/profile" component={ResearcherProfile} />
            <Route
              path="/stats/rs/edit-profile"
              component={ResearcherEditProfile}
            />
            <Route path="/stats/rs/dashboard" component={Dashboard} />
            <Route
              path="/stats/rs/pubStudyAreaDist"
              component={PubStudyAreaDist}
            />
            <Route
              path="/stats/rs/pubStudyCategoryDist"
              component={PubStudyCategoryDist}
            />
            <Route
              path="/stats/rs/pubCountByYears"
              component={PubCountByYears}
            />
            <Route path="/stats/rs/lecturingScore" component={LecturingScore} />
            <Route path="/stats/rs/journals" component={Journals} />
            <Route path="/stats/rs/courses" component={Courses} />
            <Route path="/stats/rs/q-dist" component={QDist} />
            <Route path="/stats/ou/dashboard" component={OUDashboard} />
            <Route path="/stats/ou/sdgWall" component={OrgUnitSdgWall} />
            <Route
              path="/stats/ou/pubStudyAreaDist"
              component={OUPubStudyAreaDist}
            />
            <Route
              path="/stats/ou/pubStudyCategoryDist"
              component={OUPubStudyCategoryDist}
            />
            <Route
              path="/stats/ou/pubCountByYears"
              component={OUPubCountByYears}
            />
            <Route path="/stats/ou/journals" component={OUJournals} />
            <Route path="/stats/ou/q-dist" component={OUQDist} />
            <Route path="/stats/home/makaleSayisi" component={MakaleSayisi} />
            <Route path="/stats/home/dergiDagilimi" component={DergiDagilimi} />
            <Route path="/stats/home/enCokAtif" component={EnCokAtif} />
            <Route path="/stats/reports/q-dist" component={ReportsQDist} />
            <Route
              path="/stats/reports/yayinSayisi"
              component={ReportsYayinSayisi}
            />
            <Route
              path="/stats/reports/masterTeziSayisi"
              component={ReportsMasterTeziSayisiSayisi}
            />
            <Route
              path="/stats/reports/doktoraTeziSayisi"
              component={ReportsDoktoraTeziSayisiSayisi}
            />
            <Route
              path="/stats/reports/scimagoTurkey"
              component={ScimagoTurkey}
            />
            <Route
              path="/stats/reports/scimagoWorldwide"
              component={ScimagoWorldwide}
            />
            <Route
              exact
              path="/stats/reports/reportsWorldChart"
              component={ReportsWorldChart}
            />
            <Route path="/stats/awards/awards" component={Awards} />
            <Route path="/stats/equipments/equipments" component={Equipments} />
            <Route
              exact
              path="/stats/handle/:firstId/:secondId"
              component={HandleVistorChart}
            />
            <Route
              exact
              path="/stats/handle/:firstId/:secondId/sobiad"
              component={Sobiad}
            />
            <Route
              exact
              path="/stats/handle/:firstId/:secondId/semantic-scholar"
              component={SemanticScholar}
            />
            <Route
              exact
              path="/stats/handle/:firstId/:secondId/open-citations"
              component={OpenCitations}
            />
            <Route
              exact
              path="/stats/handle/:firstId/:secondId/sdgWall"
              component={HandleSdgWall}
            />
            <Route
              exact
              path="/stats/handle/:firstId/:secondId/semantic-scholar/recommendation"
              component={SemanticScholarRecommendationTable}
            />
          </>
        )}
      </Switch>
    </Router>
  );
}

export default App;
